define('webshopProductsCategoriesListCategoryView',[
  'webshopProductsCategoriesI18n',
  'app',
  'module',
  'underscore',
  'modalsConfirmationView',
  'webshopProductsCategoriesListAutocompleteView',
  'entities/webshop/categories',
  'template!webshopProductsCategoriesListCategoryView'
], function (
  translate,
  App,
  Module,
  _,
  ConfirmationView,
  AutocompleteView,
  Categories,
  Tpl
) {
  'use strict';

  /**
   * One category cell of a product row (field.index = column number).
   *
   * Filled cell: click copies the category to the page clipboard, the cross
   * removes the product from the category.
   * Empty cell: a text input with autocomplete on the categories (code or
   * name) adds the product to the chosen category, the paste icon adds the
   * copied one.
   */
  Module.exports = AutocompleteView.extend({
    template: Tpl,
    className: 'webshop-products-categories-list-category-view ' + AutocompleteView.prototype.className,

    ui: _.extend({}, AutocompleteView.prototype.ui, {
      remove: '.chip .remove',
      paste: '.empty .paste'
    }),

    events: _.extend({}, AutocompleteView.prototype.events, {
      'click @ui.chip': 'onCopy',
      'click @ui.remove': 'onRemove',
      'click @ui.paste': 'onPaste'
    }),

    modelEvents: {
      'change:categories': 'render'
    },

    initialize: function () {
      AutocompleteView.prototype.initialize.apply(this, arguments);
      this.listenTo(this.tableView.clipboard, 'change', this.render);
    },

    getCategory: function () {
      var categories = this.model.get('categories');
      if (!categories)
        return null;
      return categories[this.field.index] || null;
    },

    serializeData: function () {
      var category = this.getCategory();
      var clipboard = this.tableView.clipboard;
      var categories = this.model.get('categories');

      return {
        texts: {
          copy: translate('webshop.products.categories.cell.copy', 'click to copy'),
          remove: translate('webshop.products.categories.cell.remove', 'Remove from this category'),
          add: translate('webshop.products.categories.cell.add', 'Add a category'),
          paste: translate('webshop.products.categories.cell.paste', 'Paste')
        },
        loaded: categories !== undefined && categories !== null,
        // only the first free cell of the row is active
        free: !category && categories && this.field.index === categories.length,
        category: category ? {
          code: category.code,
          name: category.name || category.label || category.code,
          copied: String(clipboard.get('id')) === String(category.id)
        } : null,
        clipboard: clipboard.get('id') !== '' ? {
          code: clipboard.get('code'),
          alreadyIn: this.hasCategory(clipboard.get('id'))
        } : null
      };
    },

    hasCategory: function (id) {
      return _.some(this.model.get('categories') || [], function (category) {
        return String(category.id) === String(id);
      });
    },

    isExcluded: function (category) {
      return this.hasCategory(category.id);
    },

    onSelect: function (category) {
      this.update(App.request('webshop.categories.products.add', category.id, [this.model.getId()]));
    },

    refresh: function () {
      return this.tableView.refreshProduct(this.model);
    },

    onCopy: function (e) {
      e.stopPropagation();
      var category = this.getCategory();
      if (!category)
        return;

      this.tableView.clipboard.set({
        id: category.id,
        code: category.code,
        name: category.name || category.label || category.code
      });
    },

    onRemove: function (e) {
      e.stopPropagation();
      var category = this.getCategory();
      if (!category)
        return;

      ConfirmationView.prototype.open({
        title: translate('webshop.products.categories.cell.remove.title', 'Remove from category'),
        text: translate('webshop.products.categories.cell.remove.text', 'Remove "%p" from the category "%c"?')
          .replace('%p', this.model.getCode())
          .replace('%c', category.code),
        onConfirm: _.bind(function () {
          this.update(App.request('webshop.categories.products.delete', category.id, [this.model.getId()]));
        }, this)
      });
    },

    onPaste: function (e) {
      e.stopPropagation();
      var id = this.tableView.clipboard.get('id');
      if (id === '' || this.hasCategory(id))
        return;

      this.update(App.request('webshop.categories.products.add', id, [this.model.getId()]));
    }
  });
});

